/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import React from "react"
import { useSelector } from "react-redux"

import {
    LOW_DEMAND_MODE,
    PRIOR_USE,
    TYPE_B,
} from "const"
import { ProvenType, SilMode, SilType } from "client/utils"
import { StoreType, LangType } from "client/store"
import { InsufficientData, NotCompliant } from "client/components"

interface SilWrapperProps {
    data: string
}
const SilWrapper = ({ data }: SilWrapperProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <span>
            {`${data} ${lang.capable}`}
        </span>
    )
}

interface Iec_61511_2016 {
    type: SilType
    mode: SilMode
    provenInUse: ProvenType
    dc: string | number | boolean
    lang: LangType
    silOnly?: boolean
    textError?: boolean
}
export const iec_61511_2016_device = (props: Iec_61511_2016) => {
    const { type, mode, provenInUse, lang, silOnly, textError } = props
    const dc = typeof props.dc === "string" ? parseFloat(props.dc) : props.dc

    if (provenInUse === PRIOR_USE) {
        if (dc === false || dc === null) return textError ? lang.insufficientData : <InsufficientData />

        if (type === TYPE_B && dc < 0.6) return textError ? lang.notCompliant : <NotCompliant />

        if (mode === LOW_DEMAND_MODE) return silOnly ? lang.sil_2 : <SilWrapper data={lang.sil_2} />
        return silOnly ? lang.sil_1 : <SilWrapper data={lang.sil_1} />
    }
    return textError ? lang.notCompliant : <NotCompliant />
}
